export enum KanbanStatus {
  TODO,
  IN_PROGRESS,
  DONE
}
